import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { ENV } from '@config/envConfig';
import { isAzureLoginEnabled } from '@config/ssoConfig';

const AuthAzure = ({ children }: { children: React.ReactElement }) => {
  const azureLoginEnabled = isAzureLoginEnabled();
  const authorityId = ENV.VITE_SP_ENTITY_ID || import.meta.env.VITE_SP_ENTITY_ID;
  const applicationId = ENV.VITE_SP_CLIENT_ID || import.meta.env.VITE_SP_CLIENT_ID;
  const redirectUri = ENV.VITE_SP_REDIRECT_URI || import.meta.env.VITE_SP_REDIRECT_URI;

  const configuration: Configuration = {
    auth: {
      clientId: applicationId,
      redirectUri,
      authority: `https://login.microsoftonline.com/${authorityId}`,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
  const pca = new PublicClientApplication(configuration);

  return (
    azureLoginEnabled ? (
      <MsalProvider instance={pca}>
        {children}
      </MsalProvider>
    ) : children
  );
};

export default AuthAzure;
